export const UTP = [
  {
    title: 'Быстрый выход на сделку',
    description: 'Продвигают объекты, по которым с большей вероятностью позвонят или напишут в чат',
  },
  {
    title: 'Прозрачный результат',
    description: 'Списание ставки за уникальный просмотр в поиске, рекомендациях или на карте',
  },
  {
    title: 'Индивидуальная настройка',
    description: 'Подключите ко всем объявлениям сразу или выберите объекты в Гибкой стратегии',
  },
];
